
// Generated with baseline-styles - Do not modify.
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styles = {
    "grid": "grid-b269a914",
    "nowrap": "nowrap-b269a914",
    "fit-width": "fit-width-b269a914",
    "fit-height": "fit-height-b269a914",
    "fit-both": "fit-both-b269a914",
    "fitWidth": "fit-width-b269a914",
    "fitHeight": "fit-height-b269a914",
    "fitBoth": "fit-both-b269a914"
};
exports.styleSource = ".grid-b269a914{position:relative;display:grid}.nowrap-b269a914>*{white-space:nowrap}.fit-width-b269a914{width:100%}.fit-height-b269a914{height:100%}.fit-both-b269a914{width:100%;height:100%}";
exports.default = exports.styles;
            
module.moduleType = "style";
